
import {
  defineComponent,
  PropType,
  ref,
  watch,
} from 'vue';
import { useI18n } from 'vue-i18n';
import BaseInputNumber from '@/components/fields/partials/BaseInputNumber.vue';
import FieldErrors from '@/components/fields/partials/FieldErrors.vue';
import { asInt } from '@/helpers';
import type { ABTestData } from './index';

export default defineComponent({
  name: 'ABTestForm',

  components: {
    BaseInputNumber,
    FieldErrors,
  },

  props: {
    modelValue: {
      type: Object as PropType<ABTestData>,
      required: true,
    },
    formValidation: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },

  emits: ['update:modelValue'],

  setup(props, { emit }) {
    const { t } = useI18n();
    const componentFieldErrorsKey = ref(0);

    watch(() => props.formValidation, () => {
      componentFieldErrorsKey.value += 1;
    });

    const outputsNumber = ref(asInt(props.modelValue.outputs_number_test) || 2);
    const initialOutputs = props.modelValue.initial_number_outputs ?? outputsNumber.value;

    watch(outputsNumber, (newValue) => {
      // Calculate which outputs to delete when decreasing
      let outputsToDelete: string[] | undefined;
      if (newValue < initialOutputs) {
        // Generate list of outputs to remove (e.g., if going from 4 to 2, remove output_3 and output_4)
        outputsToDelete = [];
        for (let i = newValue + 1; i <= initialOutputs; i++) {
          outputsToDelete.push(`output_${i}`);
        }
      }

      emit('update:modelValue', {
        ...props.modelValue,
        outputs_number_test: newValue,
        initial_number_outputs: initialOutputs,
        outputs_to_delete: outputsToDelete,
      });
    });

    return {
      t,
      outputsNumber,
      componentFieldErrorsKey,
    };
  },
});
